import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["iconId", "ariaLabel"];
var Icon = function Icon(_ref) {
  var iconId = _ref.iconId,
    ariaLabel = _ref.ariaLabel,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    role: ariaLabel || rest['aria-describedby'] ? null : 'presentation',
    "aria-hidden": !(ariaLabel || rest['aria-describedby']),
    className: "icon " + iconId,
    "aria-label": ariaLabel,
    "data-contrast": "svg-fill"
  }, rest), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#" + iconId
  }));
};
export default Icon;